import superagent from 'superagent'

export const setNotifications = notifications => ({
  type: 'SET_NOTIFICATIONS',
  payload: notifications
})

export const _deleteAllNotifications = () => ({
  type: 'DELETE_ALL_NOTIFICATIONS',
  payload: []
})

export const addNotification = notification => (dispatch, getState) => {
  const notifications = getState().notifications
  notifications.unshift(notification)
  dispatch(setNotifications(notifications))
}

export const deleteNotification = id => (dispatch, getState) => {
  const notifications = getState().notifications,
    token = getState().auth.token
  dispatch(setNotifications(notifications.filter(notification => notification.id !== id)))

  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/Notification/Delete/${id}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        }
        else {
          resolve(res)
        }
      })
  })
}

export const deleteAllNotifications = () => (dispatch, getState) => {
  dispatch(_deleteAllNotifications())
  const token = getState().auth.token
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/Notification/DeleteAll`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        }
        else {
          resolve(res)
        }
      })
  })
}

export const markAsRead = () => (dispatch, getState) => {
  const notifications = getState().notifications
  dispatch(setNotifications(notifications.map(notification => {
    notification.read = true
    return notification
  })))
}

export const sendNotification = notificationObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/notification/send`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(notificationObj))
      .end((err, res) => {
        if (err) {
          reject(err)
          resolve(res)
        } else {
          resolve(res)
        }
      })
  })
}

export const getNotification = () => (dispatch, getState, token) => {
  let localNotifications = getState().notifications
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/Notification/Get`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          //prioritize local notifications for read status
          const remoteNotifications = res.body.results
          remoteNotifications.forEach(notification => {
            if (!localNotifications.some(lnotification => lnotification.id === notification.id)) {
              localNotifications.push(notification)
            }
          })
          const idsToFilter = [2, 5, 9, 10, 12]

          localNotifications = localNotifications.filter(message => {
            const messageTypeId = message.MessageTypeId ? message.MessageTypeId : message.messageTypeId
            if (messageTypeId === 3) {
              message.body = `${message.fromUser.fullName} started sharing location.`
            }
            if (messageTypeId === 4) {
              message.body = `${message.fromUser.fullName} stopped sharing location.`
            }
            return idsToFilter.indexOf(parseInt(messageTypeId)) == -1
          })
          // this.setState({ messageList: notifications }, () => {
          //   //check every minute
          //   notificationUpdater = setTimeout(this.updateNotifications, 60000)
          // })

          dispatch(setNotifications(localNotifications))
          resolve(res.body.results)
        }
      })
  })
}
